import React from "react";
import { Link } from "react-router-dom";
import JurisdictionIcon from "../../../components/Atomos/Icons/JurisdictionIcon";
import type { MemberSearchJurisdiction } from "../../../Services/MemberSearch";
import {
  buildFirmPath,
  buildJurisdictionPath,
} from "../../../utils/memberSearchNavigation";
import "../../../pages/AboutUs/AboutUs.css";

type MemberSearchJurisdictionCardProps = {
  jurisdiction: MemberSearchJurisdiction;
};

const MemberSearchJurisdictionCard: React.FC<MemberSearchJurisdictionCardProps> = ({
  jurisdiction,
}) => {
  const jurisdictionPath = buildJurisdictionPath(jurisdiction);
  const firmPath = jurisdiction.firmName
    ? buildFirmPath({
        id: jurisdiction.firmId,
        name: jurisdiction.firmName,
        legacyId: jurisdiction.firmLegacyId,
        shortId: jurisdiction.firmShortId,
      })
    : null;

  return (
    <div className="flex items-center gap-6 py-2 md:gap-8">
      <div className="flex h-[117px] w-[192px] shrink-0 items-center justify-center border border-gray-200 bg-white p-3">
        <JurisdictionIcon className="h-16 w-16 shrink-0 md:h-20 md:w-20" />
      </div>

      <div className="min-w-0 flex-1 space-y-1">
        {jurisdictionPath ? (
          <Link
            to={jurisdictionPath}
            className="council-firm block text-left !text-[20px] !font-bold leading-snug transition-colors hover:text-red-600 hover:underline"
          >
            {jurisdiction.name}
          </Link>
        ) : (
          <p className="council-firm m-0 text-left !text-[20px] !font-bold leading-snug">
            {jurisdiction.name}
          </p>
        )}

        {jurisdiction.firmName ? (
          firmPath ? (
            <Link
              to={firmPath}
              className="council-services m-0 block text-left text-base leading-none transition-colors hover:text-red-600 hover:underline md:text-lg"
            >
              {jurisdiction.firmName}
            </Link>
          ) : (
            <p className="council-services m-0 text-left text-base  leading-none md:text-lg">
              {jurisdiction.firmName}
            </p>
          )
        ) : null}
      </div>
    </div>
  );
};

export default MemberSearchJurisdictionCard;
